import { Route, Routes } from "react-router-dom";
import RegisterUser from "@/pages/auth/User/RegisterUser";
import Users from "@/pages/auth/User/Users";
import NotFound from "@/components/NotFound";
import Profiles from "@/pages/auth/ProfileManagement/Profiles";
import RegisterProfile from "@/pages/auth/ProfileManagement/RegisterProfile";
import Licenca from "@/pages/auth/licenca/Licenca";
import RegisterLicenca from "@/pages/auth/licenca/RegisterLicenca";
import Clients from "@/pages/auth/client/Client";
import RegisterClient from "@/pages/auth/client/RegisterClient";
import ProtectedRoute from "./ProtectedRoute";
import Product from "@/pages/auth/Product/Product";
import Resource from "@/pages/auth/resource/Resource";


const AuthRoutes = () => {

  return (
    <Routes>
      <Route path={"*"} Component={NotFound} />


        {/* --- Módulo de Licenças (Protegido por permissão) --- */}
      <Route element={<ProtectedRoute requiredPermission="ROLE_LICENCA_LISTAR" />}>
        <Route path="/" Component={Licenca} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_LICENCA_REGISTRAR" />}>
        <Route path="/registrar-licenca" Component={RegisterLicenca} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_LICENCA_EDITAR" />}>
        <Route path="/editar-licenca/:id" Component={RegisterLicenca} />
      </Route>
      
      {/* --- Módulo de Usuários (Protegido por permissão) --- */}
      <Route element={<ProtectedRoute requiredPermission="ROLE_USUARIO_LISTAR" />}>
        <Route path="/usuario" Component={Users} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_USUARIO_REGISTRAR" />}>
        <Route path="/usuario/registrar-usuario" Component={RegisterUser} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_USUARIO_EDITAR" />}>
        <Route path="/usuario/editar-usuario/:id" Component={RegisterUser} />
      </Route>

      {/* --- Módulo de Perfis (Protegido por permissão) --- */}
      <Route element={<ProtectedRoute requiredPermission="ROLE_PERFIL_LISTAR" />}>
        <Route path="/gestao-perfis" Component={Profiles} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_PERFIL_REGISTRAR" />}>
        <Route path="/gestao-perfis/registrar-perfil" Component={RegisterProfile} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_PERFIL_EDITAR" />}>
        <Route path="/gestao-perfis/editar-perfil/:id" Component={RegisterProfile} />
      </Route>

      {/* --- Módulo de Clientes (Protegido por permissão) --- */}
      <Route element={<ProtectedRoute requiredPermission="ROLE_CLIENTE_LISTAR" />}>
        <Route path="/gestao-clientes" Component={Clients} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_CLIENTE_REGISTRAR" />}>
        <Route path="/gestao-clientes/registrar-cliente" Component={RegisterClient} />
      </Route>
      <Route element={<ProtectedRoute requiredPermission="ROLE_CLIENTE_EDITAR" />}>
        <Route path="/gestao-clientes/editar-cliente/:id" Component={RegisterClient} />
      </Route>


       {/* --- Módulo de Produtos (Protegido por permissão) --- */}
      <Route element={<ProtectedRoute requiredPermission="ROLE_PRODUTO_LISTAR" />}>
        <Route path="/gestao-produtos" Component={Product} />
      </Route>

        {/* --- Módulo de Recursos (Protegido por permissão) --- */}
      <Route element={<ProtectedRoute requiredPermission="ROLE_RECURSO_LISTAR" />}>
        <Route path="/gestao-recurso" Component={Resource} />
      </Route>

    </Routes>
  );
};

export default AuthRoutes;
